export default __webpack_public_path__ + "static/media/shocked.c064f1b4.png";